import { createParser } from '@walmart/sophia-tagging'

export default createParser({
  fields: [
    { from: 'stepNumber', to: 'stepNumber', validate: [] },
    { from: 'stepName', to: 'stepName', validate: [] },
  ],
})
